import { useState, useContext, useEffect } from "react";
import {
  FaArrowAltCircleRight,
  FaEdit,
  FaGlobe,
  FaIdBadge,
  FaPlusCircle,
  FaSearch,
  FaTrashAlt,
  FaUser,
  FaUserCircle,
  FaChartLine,
  FaCalendarAlt,
  FaFemale,
  FaMale,
} from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import ClientPageModal from "pages/extranet/client/client pager";
import Dialogs from "components/ui/dialogs/dialogs";
import SearchField from "components/ui/controls/search-field";
import { User } from "../Api/ApiUser";
import ImportClientSofracoPage from "pages/extranet/client/import client sofraco pager";
import { AuthContext } from "components/auth/auth-provider";
import {
  createStyledButton,
  cardActionButtonStyles,
  getHoverEffects,
} from "components/ui/controls/button/button-styles";
import { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import "./ListeClients.css";

// Fonction pour obtenir l'icône selon la civilité
const getCiviliteIcon = (civilite) => {
  const lowerCiv = civilite?.toLowerCase() || "";
  if (lowerCiv.includes("mme") || lowerCiv.includes("madame")) {
    return <FaFemale style={{ fontSize: "16px", color: "#22c55e" }} />;
  } else if (lowerCiv.includes("mr") || lowerCiv.includes("monsieur")) {
    return <FaMale style={{ fontSize: "16px", color: "#3b82f6" }} />;
  }
  return <FaUserCircle style={{ fontSize: "16px", color: "#6b7280" }} />;
};

// Fonction pour obtenir le style du fond de l'icône selon la civilité
const getCiviliteIconBackground = (civilite) => {
  const lowerCiv = civilite?.toLowerCase() || "";
  if (lowerCiv.includes("mme") || lowerCiv.includes("madame")) {
    return "#dcfce7"; // Vert plus foncé pour Madame (identique au style de l'icône d'édition)
  } else if (lowerCiv.includes("mr") || lowerCiv.includes("monsieur")) {
    return "#e3f2fd"; // Bleu pour Monsieur
  }
  return "#f3f4f6"; // Gris par défaut
};

// Fonction pour formatter la date de naissance (format DDMMYYYY vers DD/MM/YYYY)
const formatDateNaissance = (dateString, civilite) => {
  if (!dateString || dateString.length !== 8) {
    return "Date non renseignée";
  }

  const jour = parseInt(dateString.slice(0, 2), 10);
  const mois = parseInt(dateString.slice(2, 4), 10);
  const annee = dateString.slice(4, 8);

  const moisNoms = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];

  const moisNom = moisNoms[mois - 1] || "";
  const prefix =
    civilite?.toLowerCase().includes("mme") ||
    civilite?.toLowerCase().includes("madame")
      ? "née le"
      : "né le";

  return `${prefix} ${jour} ${moisNom} ${annee}`;
};

// Composant ClientCard moderne
const ClientCard = ({ client, onEdit, onDelete, onViewAudits }) => {
  return (
    <div className="client-card">
      <div className="client-card-main">
        <div className="client-card-info">
          <div
            className="client-card-avatar"
            style={{ backgroundColor: getCiviliteIconBackground(client.Civilite) }}
          >
            {getCiviliteIcon(client.Civilite)}
          </div>

          <div style={{ flex: 1 }}>
            <div className="client-card-row">
              <h4 className="client-card-title">
                {client.Civilite} {client.Nom} {client.Prenom}
              </h4>
            </div>
            <div className="client-card-date">
              <FaCalendarAlt style={{ fontSize: "11px", color: "#666" }} />
              <span>
                {formatDateNaissance(client.DateNaissance, client.Civilite)}
              </span>
            </div>
          </div>
        </div>
        <div className="client-card-actions">
          <Button
            onClick={onViewAudits}
            {...createStyledButton("secondary", "blue")}
          >
            <FaChartLine style={{ fontSize: "12px" }} />
            <span>Accéder aux audits</span>
          </Button>
          <Button
            onClick={onEdit}
            icon
            {...createStyledButton("card-action", "cardEdit")}
          >
            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
          </Button>
          <Button
            onClick={onDelete}
            icon
            {...createStyledButton("card-action", "delete")}
          >
            <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
          </Button>
        </div>
      </div>
    </div>
  );
};

const ListeClients = (props) => {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalCrm, setmodalCrm] = useState(false);
  const [searchText, setSearchText] = useState("");
  const authContext = useContext(AuthContext);
  useEffect(() => {
    console.log("EFFECT");
    context.handleListeClient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row center>
              <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
                <Button
                  {...createStyledButton("primary")}
                  onClick={() => {
                    context.handleNewClient();
                    setmodalOpen(true);
                  }}
                >
                  <FaPlusCircle style={{ marginRight: "8px" }} />
                  Créer un nouveau client
                </Button>
              </Column>
              <Column style={{ flex: 1 }}>
                <SearchField
                  value={searchText}
                  large
                  placeholder="Rechercher un client par son nom ou son prénom"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyUp={(e) => {
                    context.handleSearchClient(e);
                  }}
                />
                {searchText && (
                  <div style={{ 
                    marginTop: '8px', 
                    fontSize: '12px', 
                    color: '#6b7280',
                    textAlign: 'left'
                  }}>
                    {context.state.ListeClient?.length || 0} client(s) trouvé(s) pour "{searchText}"
                  </div>
                )}
              </Column>
              {authContext.utilisateur_reel?.abonnement === 3 && (
                <Column style={{ flex: "0 0 auto", marginLeft: "16px" }}>
                  <Button
                    {...createStyledButton("primary", "emerald")}
                    onClick={() => {
                      setmodalCrm(true);
                    }}
                  >
                    <FaGlobe style={{ marginRight: "8px" }} />
                    Connexion CRM
                  </Button>
                </Column>
              )}
            </Row>
          </Column>
        </CardBox>
        <CardBox>
          <Column fill>
            <Row>
              <Column scroll fill>
                <div className="liste-clients-scroll">
                  <CardBoxHeader icon={<FaUserCircle />}>
                    Liste des clients ({context.state.ListeClient?.length || 0})
                  </CardBoxHeader>

                  {context.state.ListeClient?.length === 0 ? (
                    <div className="liste-clients-empty">
                      <FaUserCircle className="liste-clients-empty-icon" />
                      <p className="liste-clients-empty-text">
                        Aucun client trouvé
                      </p>
                    </div>
                  ) : (
                    context.state.ListeClient?.map((client, index) => (
                      <ClientCard
                        key={"CLIENT" + index}
                        client={client}
                        onEdit={() => {
                          context.handleDisplayClient(client.IdClient);
                          setmodalOpen(true);
                        }}
                        onDelete={() => {
                          Dialogs.confirm(
                            "Vous êtes sur le point de supprimer la fiche de " +
                              client.Civilite +
                              " " +
                              client.Nom +
                              ". Voulez-vous continuer ?",
                            "Suppression du client",
                            () => {
                              context.handleSuppressionClient(client.IdClient);
                            }
                          );
                        }}
                        onViewAudits={() => {
                          context.handleDisplaySimulation(client.IdClient);
                        }}
                      />
                    ))
                  )}
                </div>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
      <Modal
        width="80%"
        height="80%"
        title="Fiche client"
        icon={<FaGlobe />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ClientPageModal
          visible={modalOpen}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
      <Modal
        width="40%"
        height="40%"
        title="Fiche client"
        icon={<FaGlobe />}
        visible={modalCrm}
        onClose={() => {
          setmodalCrm(false);
        }}
      >
        <ImportClientSofracoPage
          visible={modalOpen}
          onClose={() => {
            setmodalCrm(false);
          }}
        />
      </Modal>
    </>
  );
};

export default ListeClients;
